<script>
  import Login from "../components/account/login.svelte";
  import { createEventDispatcher } from "svelte";
  import wrappedFetch from "../wrappedFetch.js";
  export let username = "";
  export let hash = false;
  const dispatch = createEventDispatcher();
  let showNotification = false;


  if (hash && hash == 'true'){
    showNotification = true;
  }

</script>

<svelte:head>
  <title>Sign In | eAdmissions</title>
</svelte:head>

<section class="hero is-fullheight" style="background-color: #407f8a;">
  <div class="hero-body">
    <div class="container">
      {#if showNotification}
        <div class="columns is-centered">
          <div class="column is-7-tablet is-6-desktop is-5-widescreen">
            <div class="notification" style="background-color: #416EA1;color:white">
              Your email address has now been validated successfully.
              <br />
              Please sign in below.
            </div>
          </div>
        </div>
      {/if}
      <div style="text-align:center;">
        <a class="" href="/">
          <img
            style="height:40px"
            src="/eamissions-logo.png"
            alt="eAdmissions Logo"
            title="Go to home page" />
        </a>
      </div>
      <div class="columns is-centered">
        <div class="column is-7-tablet is-6-desktop is-5-widescreen">
            <Login
              on:pageChange={event => dispatch('pageChange', event.detail)}
              {username}
              {hash} />
        </div>
      </div>
    </div>
  </div>
</section>
